
import { NewPeriodSelectorItem } from './new-period-selector-item';
import { NewPeriodSelectorIntervalType } from 'src/app/core/enums/newPeriodSelectorIntervalType';
import { NewCropCyclePeriodFilter } from 'src/app/core/models/period-selector/newCropCyclePeriodFilter';

export class NewCropCyclePeriodSelectorItem extends NewPeriodSelectorItem {
  
  constructor(name: string) {
    super(name);
    this.intervalType = NewPeriodSelectorIntervalType.CropCycle;
  }

  getPreviousPeriodFilter = (currentPeriodFilter) => {
    const newCropCyclePeriodFilter = new NewCropCyclePeriodFilter();
    newCropCyclePeriodFilter.periodInterval = currentPeriodFilter.periodInterval;
    newCropCyclePeriodFilter.intervalLength = currentPeriodFilter.intervalLength - 1;
    return newCropCyclePeriodFilter;
  }

  getNextPeriodFilter = (currentPeriodFilter) => {
    const newCropCyclePeriodFilter = new NewCropCyclePeriodFilter();
    newCropCyclePeriodFilter.periodInterval = currentPeriodFilter.periodInterval;
    newCropCyclePeriodFilter.intervalLength = currentPeriodFilter.intervalLength + 1;
    return newCropCyclePeriodFilter;
  }
}
